import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface LastCall {
  id: string;
  number: string;
  callerName?: string;
  direction: 'incoming' | 'outgoing';
  status: 'answered' | 'missed' | 'outgoing';
  time: string; // ISO string for serialization
  duration?: number;
  recordingfile?: string;
}

interface LastCallStore {
  lastCall: LastCall | null;
  setLastCall: (call: LastCall) => void;
  updateLastCallRecording: (recordingfile: string) => void;
  clearLastCall: () => void;
}

export const useLastCallStore = create<LastCallStore>()(
  persist(
    (set, get) => ({
      lastCall: null,
      setLastCall: (call) => set({ lastCall: call }),
      updateLastCallRecording: (recordingfile) => {
        const current = get().lastCall;
        if (current) {
          set({ lastCall: { ...current, recordingfile } });
        }
      },
      clearLastCall: () => set({ lastCall: null }),
    }),
    {
      name: 'last-call-storage', // localStorage key
    }
  )
);
